import { Navigate } from "react-router-dom";
import authService from "../../services/common/authService";

const PublicRoute = ({ element: Element, clearStorage = false }) => {
  if (clearStorage) {
    localStorage.clear();
  }

  const isAuthenticated = authService.getCurrentUser();

  if (isAuthenticated) {
    // React Router way — no full reload
    return <Navigate to="/dashboard" replace />;
  }

  return <Element />;
};

export default PublicRoute;
